'use strict';

module.exports = function(str){
	return str?
			str.charAt(0).toUpperCase() + str.slice(1):
			''
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-style-normalizer/src/toUpperFirst.js
 ** module id = 360
 ** module chunks = 0
 **/